"use client";

import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";

const SocialMedia = () => {
  return (
    <div className="flex flex-row gap-4">
      <Link
        href="https://www.facebook.com/cforganicwellness"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="CF Organic Wellness on Facebook"
      >
        <FontAwesomeIcon
          icon={faFacebook}
          className="w-6 h-6 text-[var(--color-text-brand-contrast)] transition duration-300 hover:text-[var(--color-link-hover)]"
        />
      </Link>

      <Link
        href="https://www.instagram.com/cf_organicwellness/?igsh=NmFjNmRidTZyNWNx"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="CF Organic Wellness on Instagram"
      >
        <FontAwesomeIcon
          icon={faInstagram}
          className="w-6 h-6 text-[var(--color-text-brand-contrast)] transition duration-300 hover:text-[var(--color-link-hover)]"
        />
      </Link>

      <Link
        href="https://www.tiktok.com/@cf_organicwellness"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="CF Organic Wellness on TikTok"
      >
        <FontAwesomeIcon
          icon={faTiktok}
          className="w-6 h-6 text-[var(--color-text-brand-contrast)] transition duration-300 hover:text-[var(--color-link-hover)]"
        />
      </Link>
    </div>
  );
};

export default SocialMedia;
